export default "__VITE_ASSET___7CCxlyO__"